
module.directive('date', function() {
    return {
        restrict: 'E',
        template: [
            '<time datetime="{{ date | date:\'YYYY-MM-DD\'}}">',
                '{{ date | date:format }}',
            '</time>'].join(''),
        scope: {date: '=', format: '@'},
    };
});

module.directive('datetime', function() {
    return {
        restrict: 'E',
        template: [
            '<time datetime="{{date.format()}}">',
                '<span class="sa">{{ date.format("LL") }}</span>',
                '<span class="small">{{ date.format("LT")}}</span>',
            '</time>'].join(''),
        scope: {date: '='},
    };
});

module.directive('ageOnDate', function() {
    return {
        restrict: 'E',
        template: [
            "This student {{ isFuture ? 'will be' : 'was' }} ",
            "<span class='age'>{{ age }}</span> years old on ",
            "<date date='date'></date"].join(''),
        scope: {birthDate: '=', date: '='},
        link: function(scope) {
            scope.$watchGroup(['birthDate', 'date'], function() {
                if (scope.date && scope.birthDate) {
                    scope.isFuture = scope.date.isAfter();
                    scope.age = scope.date.diff(scope.birthDate, 'years');
                    if (scope.age < 0) {
                        scope.age = 'not born yet';
                    }
                }
            });
        }
    };
});

module.directive('dateRange', function() {
    return {
        restrict: 'E',
        template: [
            '<date date="start" format="{{ format }}"></date>',
            '<span ng-if="end">',
                '<span>&nbsp;&ndash;&nbsp;</span>',
                '<date date="end" format="{{ format }}"></date>',
            '</span>'].join(''),
        scope: {start:'=', end: '=', format: '@'},
    };
});
